import type { Query } from '@tanstack/react-query';

export const isQuerySuccess = <T extends Query>(
    query: T,
): query is T & { readonly state: { readonly data: NonNullable<T['state']['data']> } } => {
    return query.state.status === 'success';
};
